<template>
  <div class="pop_win">
    <!--상세보기 팝업 str-->
    <div class="modal">
      <div class="modal_dialog">
        <div class="modal_content inquiry_var_pop"> <!-- 유니크한 클래스 inquiry_var_pop-->
          <div class="modal_body">
            <div class="tbl_default" style="margin-top:10px;">
              <table style="table-layout:fixed">
                <caption>변수 조회</caption>
                <thead>
                  <tr>
                    <th scope="col" style="width:144px;">변수명</th>
                    <th scope="col" style="width:200px;">변수값</th>
                    <th scope="col" style="width:200px;">예시</th>
                  </tr>
                </thead>
              </table>
            </div>
            <div class="tbl_default" style="overflow-x:hidden; overflow-y:auto; height:271px;">
              <table>
                <tbody>
                  <tr v-for="(item, index) in items" :key="index">
                    <td style="width:144px;">{{item.variableMeaning}}</td>
                    <td style="width:200px;">{{item.variableExp}}</td>
                    <td style="width:200px;">{{item.description}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--// 상세보기 팝업 end-->
  </div>
</template>

<script>

export default {
  name: 'CMP_AID_00002', // eslint-disable-line vue/name-property-casing
  components: {
  },
  props: {
    headers: { type: Array, default: () => [] },
    items: { type: Array, default: () => [] },
  },
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>

<style scoped>
  /* 시나리오상세조회 팝업 */
  .inquiry_var_pop .modal_header {margin-bottom:32px}
  .inquiry_var_pop .tbl_default table,
  .inquiry_var_pop .tbl_default table thead {border: 0;}
  .inquiry_var_pop .tbl_default table th {border: 0; padding: 0 0 5px; font-size: 16px; line-height: 24px; text-align:left; font-weight:bold; padding-left:5px;}
  .inquiry_var_pop .tbl_default table td {border: 0; padding: 5px; font-size: 16px; line-height: 24px;}
</style>
